import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed } from 'vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { SportCompetitionV2 } from '@/@types/graphql-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitionLogo',
  props: {
    competition: null
  },
  setup(__props: any) {

const props = __props as {
	competition: SportCompetitionV2;
};



const imageUrl = computed(() => {
	return props.competition?.content?.iconUrl;
});
const competitionName = computed(() => {
	return props.competition?.content?.name;
});

function getImageUrl(url: string) {
	return Vue.filter('Thumbor')({ url, imageType: 'competitor_icon' });
}

const fallbackSrc = computed(() => {
	return props.competition?.sport
		? `/${ASSETS_DIR}/img/sports/icons/sport/${props.competition?.sport?.toLowerCase()}.png`
		: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
});

return { __sfc: true,props, imageUrl, competitionName, getImageUrl, fallbackSrc, PictureComp }
}

})